export type Scene = {
  assetId: string;
  createdAt: Date | string;
  deletedAt: Date | string | null;
  groupId: string;
  id: string;
  name: string;
  updatedAt: Date | string;
  thumbnailId: string;
  contents?: string;
};

export type CreateSceneRequest = {
  name: string;
  contents: string;
};

export type UpdateSceneRequest = {
  sceneId: string;
  contents: string;
  thumbnailId: string;
};

export type UpdateUserRequest = {
  groupId?: string;
  newPassword?: string;
};

export type CreateGroupRequest = {
  name: string;
};

export type ListAssetsFilter = {
  assetTypes: ASSET_TYPE[];
};

export type CreateAssetResponse = {
  assetId: string;
};

export type AssetRequestMetadata = {
  name: string;
  type?: ASSET_TYPE;
  [key: string]: any;
};

export interface UploadAssetResult {
  success: boolean;
  message?: string;
  data?: CreateAssetResponse;
}

export enum USER_ACL {
  ADMIN,
  USER,
};

export enum ASSET_TYPE {
  TEXTURE_DATA,
  MESH_DATA,
  SCENE_DATA,
  THUMBNAIL_DATA,
};

export function AssetTypeToString(assetType: ASSET_TYPE): string {
  if (assetType === ASSET_TYPE.MESH_DATA) {
    return "Mesh";
  } else if (assetType === ASSET_TYPE.SCENE_DATA) {
    return "Scene";
  } else if (assetType === ASSET_TYPE.TEXTURE_DATA) {
    return "Texture";
  } else if (assetType === ASSET_TYPE.THUMBNAIL_DATA) {
    return "Thumbnail";
  }
  return "Unknown";
}

export type ACLResponse = {
  acl: number;
};

export type Asset = {
  id: string;
  name: string;
  path: string;
  size: number;
  type: ASSET_TYPE;
  createdBy: string;
  groupId: string;
  data: ArrayBuffer | Uint8Array; // store the actual file contents here
};